<template>
  <div>
    <paySettingFrom :idx="idx" :ref="'forms'+idx" :wages-from.sync="wagesFrom" @changeName="changeName"></paySettingFrom>
    <paySettingItem :idx="idx" :item-lists.sync="itemLists"></paySettingItem>
    <div class="center marginTop30 marginBottom20">
      <el-button type="primary" size="small" @click="subWage">提交</el-button>
    </div>
  </div>
</template>

<script>
  import paySettingFrom from "./paySettingFrom"
  import paySettingItem from "./paySettingItem"
  export default {
    name: "wagesSettings",
    components:{paySettingFrom,paySettingItem},
    props:{
      idx:{
        type:Number,
        default:0
      },
      itemLists:{
        type:Array,
        default:function(){
          return []
        }
      },
      wagesFrom:{
        type:Object,
        default:function(){
          return {
            name:"",
            empty:1,
            org:"",
            lang:1,
          }
        }
      }
    },
    data(){
      return{
        name:""
      }
    },
    methods:{
      subWage(){
        this.$refs['forms'+this.idx].submitForm()
      },
      changeName(newName){
        this.$emit("changeName",[newName,this.idx])
      }
    }
  };
</script>

<style scoped>

</style>
